const DOC_CACHE = new Map();

/**
 * Lädt ein HTML-Dokument per Fetch, parst es in ein Document
 * und speichert das Ergebnis im Cache.
 *
 * Fehlgeschlagene Requests werden bewusst wieder aus dem Cache entfernt,
 * damit ein abgelehntes Promise nicht dauerhaft für alle weiteren Kacheln
 * denselben Fehler liefert.
 */
export async function fetchDoc(url) {
    if (DOC_CACHE.has(url)) return DOC_CACHE.get(url);

    const p = fetch(url, { credentials: "same-origin" })
        .then((r) => {
            if (!r.ok) throw new Error(`HTTP ${r.status} für ${url}`);
            return r.text();
        })
        .then((html) => new DOMParser().parseFromString(html, "text/html"))
        .catch((err) => {
            DOC_CACHE.delete(url);
            throw err;
        });

    DOC_CACHE.set(url, p);
    return p;
}

/**
 * Wie fetchDoc, wirft aber nicht: liefert bei HTTP- oder Netzwerkfehlern
 * null zurück. Nötig, damit ein 404 auf der Detailseite nur Stufe 1
 * beendet und der Fallback über die Übersichtsseite weiterlaufen kann.
 */
export async function fetchDocSafe(url) {
    try {
        return await fetchDoc(url);
    } catch (err) {
        console.warn(`[inject] ${err.message || err}`);
        return null;
    }
}
